import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { CharacterTheme, ProficiencyGroup, rulesEngineSelectors } from '@dndbeyond/character-rules-engine/es';

import { sidebarActions } from '../../../../Shared/actions';
import { appEnvSelectors } from '../../../../Shared/selectors';
import { PaneComponentEnum } from '../../../../Shared/utils';
import MobileDivider from '../../../components/MobileDivider';
import ProficiencyGroups from '../../../components/ProficiencyGroups';
import SubsectionMobile from '../../../components/SubsectionMobile';
import { SheetAppState } from '../../../typings';

interface Props extends DispatchProp {
    proficiencyGroups: Array<ProficiencyGroup>;
    isReadonly: boolean;
    theme: CharacterTheme;
}
class ProficiencyGroupsMobile extends React.PureComponent<Props> {
    handleManageShow = (): void => {
        const { dispatch, isReadonly } = this.props;

        if (!isReadonly) {
            dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.PROFICIENCIES));
        }
    };

    render() {
        const { proficiencyGroups, isReadonly, theme } = this.props;

        return (
            <SubsectionMobile name="Proficiency Groups">
                <MobileDivider
                    label="Proficiencies & Languages"
                    onClick={this.handleManageShow}
                    isReadonly={isReadonly}
                    theme={theme}
                />
                <div className="ct-proficiency-groups-mobile">
                    <ProficiencyGroups proficiencyGroups={proficiencyGroups} onClick={this.handleManageShow} />
                </div>
                <MobileDivider isEnd={true} theme={theme} />
            </SubsectionMobile>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        proficiencyGroups: rulesEngineSelectors.getProficiencyGroups(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
        theme: rulesEngineSelectors.getCharacterTheme(state),
    };
}

export default connect(mapStateToProps)(ProficiencyGroupsMobile);
